package com.patronat.top.ui.atoms.inputs

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.BasicTextField
import androidx.compose.foundation.text.KeyboardActions
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material3.Icon
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.graphics.takeOrElse
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import com.patronat.top.ui.theme.InputPlaceholderText
import com.patronat.top.ui.theme.Primary600


@Composable
fun BaseTextField(
    value: String,
    onValueChange: (String) -> Unit,
    styles: InputStyles,
    modifier: Modifier = Modifier,
    placeholder: String? = null,
    enabled: Boolean = true,
    readOnly: Boolean = false,
    leadingContent: (@Composable () -> Unit)? = null,
    leadingIcon: Painter? = null,
    trailingIcon: Painter? = null,
    keyboardOptions: KeyboardOptions = KeyboardOptions.Default,
    keyboardActions: KeyboardActions = KeyboardActions.Default,
    interactionSource: MutableInteractionSource = remember { MutableInteractionSource() }
) {
    BasicTextField(
        value = value,
        onValueChange = onValueChange,
        enabled = enabled,
        readOnly = readOnly,
        textStyle = styles.textColor,
        keyboardOptions = keyboardOptions,
        keyboardActions = keyboardActions,
        interactionSource = interactionSource,
        singleLine = true,
        cursorBrush = SolidColor(Primary600),
        modifier = modifier,
        decorationBox = { innerTextField ->
            Row(
                modifier = Modifier
                    .height(61.dp) // Web style
                    .fillMaxWidth()
                    .background(styles.backgroundColor, RoundedCornerShape(8.dp))
                    .border(styles.borderWidth, styles.borderColor, RoundedCornerShape(8.dp))
                    .padding(horizontal = 16.dp),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(10.dp)
            ) {
                if (leadingContent != null) {
                    Box(contentAlignment = Alignment.Center) {
                        leadingContent()
                    }

                    Box(
                        modifier = Modifier
                            .height(24.dp)
                            .width(1.dp)
                            .background(styles.borderColor.copy(alpha = 0.6f))
                    )
                } else if (leadingIcon != null) {
                    // Leading Icon
                    Box(modifier = Modifier.size(24.dp), contentAlignment = Alignment.Center) {
                        Icon(
                            painter = leadingIcon,
                            contentDescription = null,
                            tint = styles.iconColor
                        )
                    }
                }

                // Input + Placeholder
                Box(modifier = Modifier.weight(1f)) {
                    if (value.isEmpty() && placeholder != null) {
                        Text(
                            text = placeholder,
                            style = InputPlaceholderText,
                            color = InputPlaceholderText.color.takeOrElse { styles.placeholderColor }
                        )
                    }
                    innerTextField()
                }

                // Trailing Icon
                if (trailingIcon != null) {
                    Box(modifier = Modifier.size(24.dp), contentAlignment = Alignment.Center) {
                        Icon(
                            painter = trailingIcon,
                            contentDescription = null,
                            tint = styles.iconColor
                        )
                    }
                }
            }
        }
    )
}
